export default {
  remarks: '备注',
  'Primary key': '主键',
  'Disable Search': '禁用搜索',
  'Weight (drag and drop sorting)': '权重（拖拽排序）',
  'Status:0=Disabled,1=Enabled': '状态:0=禁用,1=启用',
  'Remote Select (association table)': '远程下拉（关联表）',
  'Remote Select (Multi)': '远程下拉（关联多选）',
  'Radio:opt0=Option1,opt1=Option2': '单选框:opt0=选项一,opt1=选项二',
  'Checkbox:opt0=Option1,opt1=Option2': '复选框:opt0=选项一,opt1=选项二',
  Multi: '（多选）',
  'Select:0=Option1,1=Option2': '下拉框:0=选项一,1=选项二',
  'Switch:0=off,1=on': '开关:0=关,1=开',
  'Time date (timestamp storage)': '时间日期（时间戳存储）',
  'If left blank, the verifier title attribute will be filled in automatically':
    '留空则自动填写验证器title属性(看不懂请直接填写完整错误消息)',
  'Weight (automatically generate drag sort button)':
    '权重（自动生成拖拽排序按钮）',
  'If it is not input, it will be automatically analyzed by the controller':
    '不输入则以控制器自动解析'
}
